
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { RecycleScroller } from 'vue-virtual-scroller'
import { mapActions, mapMutations, mapState } from 'vuex'
import utils from '@/components/tools/utils'
import AvatarSubject from '@/components/account/messages/AvatarSubject'
import WithTaskBadges from '@/components/ui/WithTaskBadges'

const subjectHeight = 96

export default {
  subjectHeight,
  components: {
    AvatarSubject,
    WithTaskBadges,
    RecycleScroller

  },
  scrollToTop: false,

  data: () => ({
    avatarSize: 62,
    messageBoardSubjectsHeight: '65vh',
    loading: false
  }),

  computed: {
    ...mapState('messages', {
      subjects: state => state.subjects,
      activeGroupKey: state => state.activeGroupKey,
      boards: state => state.boards,
      page: state => state.page,
      total: state => state.total
    })

  },

  mounted () {
    if (this.$vuetify.breakpoint.mobile) {
      this.messageBoardSubjectsHeight = '80vh'
    } else {
      this.messageBoardSubjectsHeight = this.$refs.subjectsCardText.offsetHeight - 16 + 'px'
    }
  },
  methods: {
    ...mapActions('messages', ['setActiveGroupKey', 'getNotifications', 'markAsReadByGroupKey']),
    ...mapMutations('messages', ['setPage']),

    isRead (message) {
      return message.read === true
    },

    formatDate (date) {
      return utils.formatDate(date, this.$i18n.locale)
    },

    scrollStart () {
      if (this.page > 2) {
        this.setPage(this.page - 1)
      }
    },

    scrollEnd () {
      let total = 0
      for (const key in this.boards) {
        total += this.boards[key].filter(message => message.messageId).length
      }

      if (total >= this.total) {
        // console.log('total >= this.total', total, this.total)
        return
      }
      // console.log('total < this.total', total, this.total)

      this.setPage(this.page + 1)
      this.loading = true
      this.getNotifications({ page: this.page }).then(() => {
        this.loading = false
      })
    },
    onScrollerVisible () {
      const { slug: groupKey } = this.$route.params

      if (groupKey) {
        const subjectIndex = this.subjects.findIndex(
          subject => subject.groupKey === groupKey
        )
        const subjectPosition = subjectIndex * subjectHeight
        this.$refs.scroller.scrollToPosition(subjectPosition)
        this.$axios.put(`/private/messages/read-by-slug/${groupKey}`, {})
        this.markAsReadByGroupKey(groupKey)
      }
    }
  }
}
